import useFetchApi from "@/api/hooks/useFetchApi";
import { useEffect } from "react";

interface SliderProps {
    data?: any,
    isLoading?: boolean
    setLoaded?: () => void
}

const Slider: React.FC<SliderProps> = (props) => {

    const {
        data: sliderData,
        isLoading,
        error
    } = useFetchApi({
        url: '/v1/gp/6787af0ad187a284903ccab1/tr/find?list_related=false&list_referenced=false&module_populate=6787a9e4d187a284903cbcd4&limit=0&skip=0&search=title%3A%24eq%3ASlider',
        service: 'CMS_PROC'
    })

    useEffect(() => {
        if (!sliderData) return;
        jQuery(".intro_section .flexslider").flexslider({
            // controlsContainer: ".slider-controls",
            animation: "slide",
            reverse: true,
            pauseOnHover: true,
            useCSS: true,
            controlNav: true,
            directionNav: true,
            prevText: "",
            nextText: "",
            smoothHeight: false,
            slideshowSpeed: 10000,
            animationSpeed: 450,
            start: function (slider: any) {
                // slider.find('.slide_description').children().css({'visibility': 'hidden'});
                // slider.find('.flex-active-slide .slide_description').children().each(function(index){
                // 	var self = jQuery(this);
                // 	var animationClass = !self.data('animation') ? 'fadeInRight' : self.data('animation');
                // 	setTimeout(function(){
                // 		self.addClass("animated "+animationClass);
                // 	}, index*200);
                // });
                var maxHeight: any = null;
                slider.find('.slides > li').each(function () {
                    /* @ts-ignore */
                    var slideHeight = jQuery(this).height();
                    maxHeight = (slideHeight > maxHeight) ? slideHeight : maxHeight;
                })
                jQuery('.slides').height(maxHeight);
            },
            // after :function( slider ){
            // 	slider.find('.flex-active-slide .slide_description').children().each(function(index){
            // 		var self = jQuery(this);
            // 		var animationClass = !self.data('animation') ? 'fadeInRight' : self.data('animation');
            // 		setTimeout(function(){
            // 			self.addClass("animated "+animationClass);
            // 		}, index*200);
            // 	});
            // },
            // end :function( slider ){
            // 	slider.find('.slide_description').children().each(function() {
            // 		var self = jQuery(this);
            // 		var animationClass = !self.data('animation') ? 'fadeInRight' : self.data('animation');
            // 		self.removeClass('animated ' + animationClass).css({'visibility': 'hidden'});
            // 			// jQuery(this).attr('class', '');
            // 		});
            // },
        })
            //wrapping nav with container
            .find('.flex-control-nav')
            .wrap('<div class="container nav-container"/>');
        jQuery(".intro_section .flexslider").find('.flex-direction-nav')
            .wrap('<div class="container direction-nav-container"/>')

        jQuery('.flexslider').flexslider({
            animation: "fade",
            useCSS: true,
            controlNav: true,
            directionNav: false,
            prevText: "",
            nextText: "",
            smoothHeight: false,
            slideshowSpeed: 5000,
            animationSpeed: 800,
        })

        setTimeout(() => {
            props.setLoaded && props.setLoaded()
        }, 500);
    }, [sliderData]);

    return (
        <>
            <section className="intro_section page_mainslider cs">
                <div className="flexslider" style={{ width: '100% !important' }}>
                    <ul className="slides">

                        {sliderData?.results?.map((result: any) =>
                            result?.populated?.["Anasayfa İçerikler"]?.records?.map((item: any) => (
                                <li key={item?._id}>
                                    <img src={item?.resim} className="slide-bg customSliderImg" alt={item?.title || "Slider Image"} />
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="slide_description_wrapper">
                                                    <div className="slide_description">
                                                        <div className="intro-layer">
                                                            <p className="text-uppercase bold fontsize_14 highlight kanit">
                                                                {item?.alt_baslik || ""}
                                                            </p>
                                                            <h3 className="bold big">{item?.title || "Default title"}</h3>
                                                            <p className="bold" dangerouslySetInnerHTML={{ __html: item?.content || "Default content" }}></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            ))
                        )}
                    </ul>

                </div>
                {/* eof flexslider */}
            </section>
        </>
    )
}

export default Slider;